/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";
import { AuthInitialStore } from "./types.store";

const initialState: AuthInitialStore = {
  isSpinnerVisible: false,
};

const authStore = createSlice({
  initialState,
  name: "appConfigData",
  reducers: {
    setIsSpinnerVisible: (state, action) => {
      state.isSpinnerVisible = action.payload;
    },
  },
});

export const { setIsSpinnerVisible } = authStore.actions;
export default authStore.reducer;
